// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".member-picture-edit{text-align:center}.member-picture-edit figure{margin:0;cursor:pointer}.member-picture-edit img{position:relative;width:100px;height:100px;border-radius:100%}.member-picture-edit img.no-image{left:10px}.member-picture-edit figcaption{font-family:\"GothamSSm-Book\",Arial,sans-serif;font-size:13px;color:#a9a9a9}\n", ""]);
// Exports
module.exports = exports;
